<template>
  <h3 class="navlist__title">{{ title }}</h3>
  <div class="navlist">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.navlist {
  border: 1px solid variables.$border-color;
  border-radius: 5px;
  padding: 1em;
  margin-bottom: 1.5rem;
}
</style>
